import React, { Component } from "react";
import styled from "styled-components";
import shortid from "shortid";
import { Redirect } from 'react-router-dom';

// Utils //
import history from "utils/history";

// HOC //
import withChat from "hoc/withChat";

// Components //
import SuccessMessage from 'components/SuccessMessage';
import ErrorMessage from 'components/ErrorMessage';
import View from 'components/View';
import CodeEditor from "components/CodeEditor";
import Text from "components/Text";
import StepHeader from 'components/StepHeader';
import StepFooter from 'components/StepFooter';
import Callout from 'components/Callout';

const Root = styled.div``;

const TextWrapper = styled(View)`
  margin-top: 24px;
  margin-bottom: 40px;
  & > ${ Text } + ${ Text } {
    margin-top: 24px;
  }
`;

class Step2 extends Component {
  state = {
    hasRan: false,
    value:
      `const channel = client.channel('messaging', 'the-small-council_${shortid.generate()}', {
  name: "Private Chat About the Kingdom",
  image: "https://bit.ly/2F3KEoM",
  members: ["jon-snow"],
  session: 8 // custom field, you can add as many as you want
});

await channel.watch();

return channel;`
  };

  run = async () => {
    const {
      client, // eslint-disable-line no-unused-vars
      channel, // eslint-disable-line no-unused-vars
      match, // eslint-disable-line no-unused-vars
      setError,
      setChannel,
      setLoading,
      setStepComplete,
    } = this.props;
    const { value } = this.state;

    try {
      await setLoading(true);
      const channel = await eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      await setChannel(channel);
      await setStepComplete(1);
      await setLoading(false);

      this.setState({ hasRan: true });
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push(`/step-1`);

  handleNextClick = () => history.push(`/step-3`);

  render() {
    const { client, completedSteps, error, loading } = this.props;
    const { hasRan, value } = this.state;

    const isComplete = completedSteps.includes(1);

    if (!client) {
      return <Redirect to="/step-1" />
    }

    return (
      <Root>
        <StepHeader
          step={2}
          title="Create a channel with members"
        >
          <Text size={18}>
            With the client set up, you'll want to create a channel with members:
          </Text>
        </StepHeader>
        <TextWrapper>
          <Text>
            The first argument is the <b>chat type</b>. Different chat types can have different features enabled and different permissions.
          </Text>
          <Text>
            The second argument is the <b>ID of the conversation</b> – it is optional, if you leave it out we will generate an ID based on the list of members.
          </Text>
          <Text>
            The third argument is an <b>object with all the data</b> for this channel. You can use this to store any custom metadata about this channel. Name and image are displayed by the Chat React components by default. The members list is special – it allows you to restrict a conversation to a list of specific members. The permissions these members have is configurable per chat type.
          </Text>
        </TextWrapper>
        <CodeEditor
          onChange={this.handleCodeChange}
          onRunClick={this.run}
          value={value}
          runLabel="Create Channel"
        />
        <Callout style={{marginTop: 24}}>
          <Text>
            <b>NOTE:</b> channel.watch() retrieves the current channel state (messages, members, read events etc.) and also ensures your current WebSocket connection listens to changes on this channel.
          </Text>
        </Callout>
        {hasRan && (
          <SuccessMessage
            style={{marginTop: 16}}
            text="Channel created."
          />
        )}
        <StepFooter
          disableNext={!isComplete && !hasRan}
          loading={loading}
          onNextClick={this.handleNextClick}
          onPrevClick={this.handlePrevClick}
        />
        {error && <ErrorMessage
          error={error}
        />}
      </Root>
    );
  }
}

export default withChat(Step2);
